import { memo, useEffect } from "react";
import { UnderAssessmentRow } from "../UnderAssessmentRow";
import { AppealInProgressRow } from "../AppealInProgressRow";
import { AFCAAppealRow } from "../AFCAAppealRow";
import { SOWRow } from "../SOWRow";
import { Authorized } from "../Authorized";
import { CashSettlementRow } from "../CashSettlementRow";
import { EggHatchedRow } from "../EggHatchedRow";
import { AFCASOWRow } from "../AFCASOWRow";
import { DeclinedClaimRow } from "../DeclinedClaimRow";
import { useDispatch, useSelector } from "react-redux";
import { getClaims } from "../../action";

const Claims = memo(({ type }) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.reducer);
  const jwtToken = localStorage.getItem("jwtToken");

  useEffect(() => {
    if (type === 0) {
      dispatch(getClaims());
    }
  }, [jwtToken, dispatch, type]);

  return (
    <div className="bg-white shadow-sm border rounded-lg">
      <div className="p-6">
        <p className="font-bold text-xl">Claims</p>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full font-medium text-[#6B707E]">
          <thead className="bg-[#F9FAFB]">
            <tr className="border-t border-b text-muted-foreground text-sm text-left">
              <th className="px-6 py-3 font-medium text-center">
                PROPERTY ADDRESS
              </th>
              <th className="px-6 py-3 font-medium text-center">CLIENT NAME</th>
              <th className="px-6 py-3 font-medium text-center">
                INSURER NAME
              </th>
              <th className="px-6 py-3 font-medium text-center">DESCRIPTION</th>
              <th className="px-6 py-3 font-medium text-center">STAGE</th>
              <th className="px-6 py-3 font-medium min-w-[230px] text-center">
                PROGRESS
              </th>
              <th className="px-6 py-3 font-medium text-center">ACTIONS</th>
              <th className="px-6 py-3 font-medium text-center">
                SOME INFORMATION
              </th>
            </tr>
          </thead>
          <tbody>
            {state.claimsData?.length > 0
              ? state.claimsData?.map((claim, index) =>
                  claim.status === "Authorized" ? (
                    <Authorized
                      address={claim.address}
                      description={claim.description}
                      key={index}
                      index={0}
                      claimantId={claim._id}
                      claimantName={claim.claimantName}
                      insurer={claim.insurerName}
                      status={claim.status}
                      authorizedDate={claim.timestamps.createdAt}
                      timestamps={claim.timestamps}
                    />
                  ) : claim.status === "Under Assessment" ? (
                    <UnderAssessmentRow
                      address={claim.address}
                      description={claim.description}
                      key={index}
                      index={0}
                      claimantId={claim._id}
                      claimantName={claim.claimantName}
                      insurer={claim.insurerName}
                      status={claim.status}
                      assessmentStart={claim.timestamps?.assessmentStart}
                      assessmentTimerEnds={claim.timers?.assessmentTimerEnds}
                      assessmentStartDate={claim.timestamps.assessmentStart}
                      timestamps={claim.timestamps}
                    />
                  ) : claim.status === "Appeal in Progress" ? (
                    <AppealInProgressRow
                      address={claim.address}
                      description={claim.description}
                      key={index}
                      index={0}
                      claimantId={claim._id}
                      claimantName={claim.claimantName}
                      insurer={claim.insurerName}
                      status={claim.status}
                      appealStartTime={claim.timestamps.appealStart}
                      timestamps={claim.timestamps}
                    />
                  ) : claim.status === "AFCA Appeal" ? (
                    <AFCAAppealRow
                      address={claim.address}
                      description={claim.description}
                      key={index}
                      index={0}
                      claimantId={claim._id}
                      claimantName={claim.claimantName}
                      insurer={claim.insurerName}
                      status={claim.status}
                      appealSentData={claim.timers.afcaAppealSentDate}
                      afcaAppealMadeDate={claim.timestamps.afcaAppealMadeDate}
                      timestamps={claim.timestamps}
                    />
                  ) : claim.status === "Scope of Works" ? (
                    <SOWRow
                      address={claim.address}
                      description={claim.description}
                      key={index}
                      index={0}
                      claimantId={claim._id}
                      claimantName={claim.claimantName}
                      insurer={claim.insurerName}
                      status={claim.status}
                      sowReqSentTime={claim.timestamps?.sowRequestSent}
                      buttonstatus={claim.scopeOfWorks.emailSentbuttonstatus}
                      afcaWonDate={claim.timestamps.afcaWonDate}
                      timestamps={claim.timestamps}
                    />
                  ) : claim.addedAFCASowId === undefined &&
                    claim.status === "Cash Settlement" ? (
                    <CashSettlementRow
                      address={claim.address}
                      description={claim.description}
                      key={index}
                      index={0}
                      claimantId={claim._id}
                      claimantName={claim.claimantName}
                      insurer={claim.insurerName}
                      status={claim.status}
                      type={1}
                      cashStartTime={claim.timestamps.cashSettlementDate}
                      timestamps={claim.timestamps}
                    />
                  ) : claim.addedAFCASowId === undefined &&
                    claim.status === "Egg Hatched" ? (
                    state.hideShowFinishedClaims && (
                      <EggHatchedRow
                        address={claim.address}
                        description={claim.description}
                        key={index}
                        index={0}
                        claimantId={claim._id}
                        claimantName={claim.claimantName}
                        insurer={claim.insurerName}
                        status={claim.status}
                        eggHatchedDate={claim.timestamps.eggHatchedDate}
                        choise={claim.cashSettlement.settlementChoice}
                        type={1}
                        firstQuiz={
                          claim.partiallyApprovedQuestions?.firstQuiz || ""
                        }
                        timestamps={claim.timestamps}
                      />
                    )
                  ) : claim.addedAFCASowId === undefined &&
                    claim.status === "AFCA SOW" ? (
                    <AFCASOWRow
                      address={claim.address}
                      description={claim.description}
                      key={index}
                      index={0}
                      claimantId={claim._id}
                      claimantName={claim.claimantName}
                      insurer={claim.insurerName}
                      status={claim.status}
                      sowStarttime={claim.timers.afcaSOWsentDate}
                      firstQuiz={
                        claim.partiallyApprovedQuestions?.firstQuiz || ""
                      }
                      secondQuiz={
                        claim.partiallyApprovedQuestions?.secondQuiz || ""
                      }
                      type={1}
                    />
                  ) : claim.addedAFCASowId === undefined &&
                    claim.status === "Claim Declined" ? (
                    state.hideShowFinishedClaims && (
                      <DeclinedClaimRow
                        address={claim.address}
                        description={claim.description}
                        key={index}
                        index={0}
                        claimantId={claim._id}
                        claimantName={claim.claimantName}
                        insurer={claim.insurerName}
                        status={claim.status}
                        declinedDate={claim.timestamps.declinedDate}
                        type={1}
                        timestamps={claim.timestamps}
                      />
                    )
                  ) : null
                )
              : null}
          </tbody>
        </table>
      </div>
    </div>
  );
});

export default Claims;
